import Icon from '@components/v2/ui/Icon/Icon';
import { Box, SxProps, Theme } from '@mui/material';
import { CircleAlert } from 'lucide-react';
import { MouseEvent } from 'react';

interface OrderErrorIconProps {
  testId: string;
  sx?: SxProps<Theme>;
  onClick?: () => void;
}

const OrderErrorIcon = ({ testId, sx, onClick }: OrderErrorIconProps) => {
  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    onClick?.();
  };

  return (
    <Box
      test-id={testId}
      onClick={onClick ? handleClick : undefined}
      sx={[
        { display: 'inline-flex', alignItems: 'center', color: 'error.main' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Icon icon={CircleAlert} size="sm" />
    </Box>
  );
};

export default OrderErrorIcon;
